type ColourType =
  | "text"
  | "bg"
  | "textForBg"
  | "slides"
  | "slidesNotSelected"
  | "from"
  | "oppositeBg";

const colourTable: Record<string, Array<string>> = {
  Hyacinth: [
    "text-hyacinth",
    "bg-hyacinth",
    "text-cotton",
    "text-lazer",
    "text-dark-grey",
    "from-hyacinth",
    "bg-lazer",
  ],
  Cotton: [
    "text-cotton",
    "bg-cotton",
    "text-coal",
    "text-hyacinth",
    "text-dark-grey",
    "from-cotton",
    "bg-hyacinth",
  ],
  Lazer: [
    "text-lazer",
    "bg-lazer",
    "text-coal",
    "text-hyacinth",
    "text-dark-grey",
    "from-lazer",
    "bg-hyacinth",
  ],
  DarkGrey: [
    "text-dark-grey",
    "bg-dark-grey",
    "text-coal",
    "text-hyacinth",
    "text-lazer",
    "from-dark-grey",
    "bg-hyacinth",
  ],
  Yellow: [
    "text-yellow",
    "bg-yellow",
    "text-coal",
    "text-hyacinth",
    "text-dark-grey",
    "from-yellow",
    "bg-hyacinth",
  ],
  Salmon: [
    "text-salmon",
    "bg-salmon",
    "text-coal",
    "text-hyacinth",
    "text-dark-grey",
    "from-salmon",
    "bg-hyacinth",
  ],
  Frost: [
    "text-frost",
    "bg-frost",
    "text-coal",
    "text-hyacinth",
    "text-dark-grey",
    "from-frost",
    "bg-hyacinth",
  ],
  Coal: [
    "text-coal",
    "bg-coal",
    "text-cotton",
    "text-hyacinth",
    "text-dark-grey",
    "from-coal",
    "bg-hyacinth",
  ],
  White: [
    "text-white",
    "bg-white",
    "text-coal",
    "text-hyacinth",
    "text-dark-grey",
    "from-white",
    "bg-hyacinth",
  ],
};

export function lookupColourString(
  colour?: string | null,
  colourType?: ColourType | null,
): string | undefined {
  if (!colour) {
    return undefined;
  }
  const results = colourTable[colour];
  if (!results) {
    console.error(`Failed to find colour: "${colour}"`);
    return "text-lazer bg-lazer";
  }

  switch (colourType) {
    case "bg":
      return results[1];
    case "textForBg":
      return results[2];
    case "slides":
      return results[3];
    case "slidesNotSelected":
      return results[4];
    case "from":
      return results[5];
    case "oppositeBg":
      return results[6];
    default:
      return results[0];
  }
}

export function lookupHeight(type: Queries.GraphCMS_GradientType): string {
  switch (type) {
    case "Full":
      return "h-full";
    case "Half":
      return "h-1/2";
    case "Short":
      return "h-1/3";
  }
  return "h-full";
}
